/**
 * Strips markup syntax from question text for accessibility purposes.
 * Converts "[value|key]" format to just "value".
 *
 * @example
 * stripMarkup("Do you have experience in [Cleaning|attribute]?")
 * // Returns: "Do you have experience in Cleaning?"
 */
export const stripMarkup = (text: string): string => {
    if (!text) return '';
    return text.replace(/\[([^\]]+)\]/g, (match, content: string) => {
        const parts = content.split('|');
        return parts.length > 1 ? parts.slice(0, -1).join('|') : match;
    });
};
